import 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

function Dots({
  customIconSize,
  color
}) {
  return /*#__PURE__*/jsxs("svg", {
    width: `${customIconSize}px`,
    height: `${customIconSize / 4}px`,
    viewBox: "0 0 120 30",
    xmlns: "http://www.w3.org/2000/svg",
    fill: color,
    children: [/*#__PURE__*/jsxs("circle", {
      cx: "15",
      cy: "15",
      r: "15",
      children: [/*#__PURE__*/jsx("animate", {
        attributeName: "r",
        from: "15",
        to: "15",
        begin: "0s",
        dur: "0.8s",
        values: "15;9;15",
        calcMode: "linear",
        repeatCount: "indefinite"
      }), /*#__PURE__*/jsx("animate", {
        attributeName: "fill-opacity",
        from: "1",
        to: "1",
        begin: "0s",
        dur: "0.8s",
        values: "1;.5;1",
        calcMode: "linear",
        repeatCount: "indefinite"
      })]
    }), /*#__PURE__*/jsxs("circle", {
      cx: "60",
      cy: "15",
      r: "9",
      fillOpacity: "0.3",
      children: [/*#__PURE__*/jsx("animate", {
        attributeName: "r",
        from: "9",
        to: "9",
        begin: "0s",
        dur: "0.8s",
        values: "9;15;9",
        calcMode: "linear",
        repeatCount: "indefinite"
      }), /*#__PURE__*/jsx("animate", {
        attributeName: "fill-opacity",
        from: "0.5",
        to: "0.5",
        begin: "0s",
        dur: "0.8s",
        values: ".5;1;.5",
        calcMode: "linear",
        repeatCount: "indefinite"
      })]
    }), /*#__PURE__*/jsxs("circle", {
      cx: "105",
      cy: "15",
      r: "15",
      children: [/*#__PURE__*/jsx("animate", {
        attributeName: "r",
        from: "15",
        to: "15",
        begin: "0s",
        dur: "0.8s",
        values: "15;9;15",
        calcMode: "linear",
        repeatCount: "indefinite"
      }), /*#__PURE__*/jsx("animate", {
        attributeName: "fill-opacity",
        from: "1",
        to: "1",
        begin: "0s",
        dur: "0.8s",
        values: "1;.5;1",
        calcMode: "linear",
        repeatCount: "indefinite"
      })]
    })]
  });
}

export { Dots };
